export const dashboard = {
  title: '儀表板',
  welcome: '歡迎使用 %{companyName} 管理系統',
  vsYesterday: '對比昨日',
  stats: {
    totalSites: '充電站總數',
    totalChargers: '充電樁總數',
    activeChargers: '使用中充電樁',
    chargingSessions: '充電次數',
    sessionsToday: '今日充電次數',
    totalUsers: '使用者總數',
    todayTransactions: '今日交易',
    todayRevenue: '今日收入',
    totalRevenue: '總收入',
    energyDelivered: '供電量',
    activeSessions: '進行中充電',
    liveNow: '即時',
    accessible: '可存取',
  },
  chargerStatus: {
    title: '充電樁狀態',
    available: '可用',
    charging: '充電中',
    offline: '離線',
    faulted: '故障',
    other: '其他',
    networkHealth: '網絡健康度',
    needsAttention: '個充電樁需要關注',
  },
  recentSessions: {
    title: '最近完成的充電',
    subtitle: '網絡中最新的充電記錄',
    noSessions: '沒有找到最近的充電記錄',
    duration: '時長',
    energy: '電量',
    revenue: '收入',
  },
};
